var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66797 5.33398C2.5634 5.33398 1.66797 6.22942 1.66797 7.33398V15.334C1.66797 16.4386 2.5634 17.334 3.66797 17.334H15.668C16.7725 17.334 17.668 16.4386 17.668 15.334V7.33398C17.668 6.22942 16.7725 5.33398 15.668 5.33398H14.0822C13.817 5.33398 13.5626 5.22863 13.3751 5.04109L12.2538 3.91977C11.8787 3.5447 11.37 3.33398 10.8395 3.33398H8.4964C7.96596 3.33398 7.45726 3.5447 7.08218 3.91977L5.96086 5.04109C5.77333 5.22863 5.51897 5.33398 5.25375 5.33398H3.66797ZM9.66797 14.334C11.3248 14.334 12.668 12.9908 12.668 11.334C12.668 9.67713 11.3248 8.33398 9.66797 8.33398C8.01111 8.33398 6.66797 9.67713 6.66797 11.334C6.66797 12.9908 8.01111 14.334 9.66797 14.334Z",
    fill: "#888DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.bd3f7bf84a807265005c79f7aacb3b85.svg";
export { ForwardRef as ReactComponent };